import { useDispatch } from 'react-redux';

import { DefaultPhoneNumber, TextUs } from 'src/app/components/Elements/Location';
import { openChat } from 'src/app/state/slices/chat';
import { IS_MOBILE } from 'src/consts';

import { ErrorCard, LinkStyleButton } from './styles';

export const NoAvailableDeliveryWindowsCard = () => {
  const dispatch = useDispatch();
  const handleOnChatClick = () => dispatch(openChat());
  return (
    <ErrorCard>
      Oh no! It looks like we’re unable to find any delivery windows.
      <br />
      <br />
      Please contact us at <DefaultPhoneNumber /> or chat with us{' '}
      {IS_MOBILE ? (
        <TextUs generalContactNumber>here</TextUs>
      ) : (
        <LinkStyleButton onClick={handleOnChatClick}>here</LinkStyleButton>
      )}{' '}
      for further assistance.
    </ErrorCard>
  );
};
